// import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
// import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';

// import { routes } from './app.routes';
// import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
// import { provideServiceWorker } from '@angular/service-worker';
// import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
// import { AuthInterceptor } from './app-core/interceptors/auth.interceptor';
// import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
// import { MAT_DATE_LOCALE } from '@angular/material/core';
// import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
// import { ErrorCatchingInterceptor } from './app-core/interceptors/error-catching.interceptor';
// import { LoadingInterceptor } from './app-core/interceptors/loading.interceptor';
// import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import OktaAuth from '@okta/okta-auth-js';
// import { environment } from '../environments/environment';
// import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
// import localePl from '@angular/common/locales/pl';
// import { ConfirmDeleteInterceptor } from './app-core/interceptors/confirm-delete.interceptor';

// registerLocaleData(localePl);

// const DEFAULT_LANG = localStorage.getItem('language') || 'pl-PL';

// const oktaAuth = new OktaAuth(environment.okta);
// export const appConfig: ApplicationConfig = {
//   providers: [
//     provideZoneChangeDetection({ eventCoalescing: true }),
//     provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
//     provideAnimationsAsync(),
//     provideServiceWorker('ngsw-worker.js', {
//       enabled: !isDevMode(),
//       registrationStrategy: 'registerWhenStable:30000'
//     }),
//     provideHttpClient(withInterceptorsFromDi()),
//     importProvidersFrom([
//       OktaAuthModule,
//       TranslateModule.forRoot({
//         loader: {
//           provide: TranslateLoader,
          
//           useFactory: function (http: HttpClient) {
//             return new TranslateHttpLoader(http, `/i18n/`);
//           },
//           deps: [HttpClient]
//         }
//       })
//     ]),
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: AuthInterceptor,
//       multi: true
//     },
//     {
//       provide: DATE_PIPE_DEFAULT_OPTIONS,
//       useValue: { dateFormat: 'yyyy-MM-dd' }
//     },
//     {
//       provide: MAT_DATE_LOCALE,
//       useValue: DEFAULT_LANG
//     },
//     {
//       provide: LOCALE_ID,
//       useValue: DEFAULT_LANG
//     },
//     {
//       provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
//       useValue: { appearance: 'outline' }
//     },
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: ErrorCatchingInterceptor,
//       multi: true
//     },
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: ConfirmDeleteInterceptor,
//       multi: true
//     },
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: LoadingInterceptor,
//       multi: true
//     },
//     {
//       provide: HTTP_INTERCEPTORS,
//       useClass: AuthInterceptor,
//       multi: true
//     },
//     {
//       provide: OKTA_CONFIG,
//       useValue: { oktaAuth }
//     },
//   ]
// };
import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter, withComponentInputBinding, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideServiceWorker } from '@angular/service-worker';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './app-core/interceptors/auth.interceptor';
import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ErrorCatchingInterceptor } from './app-core/interceptors/error-catching.interceptor';
import { LoadingInterceptor } from './app-core/interceptors/loading.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import localePl from '@angular/common/locales/pl';
import { ConfirmDeleteInterceptor } from './app-core/interceptors/confirm-delete.interceptor';
import { environment } from '../environments/environment';

registerLocaleData(localePl);

const DEFAULT_LANG = localStorage.getItem('language') || 'pl-PL';

// Konfiguracja Okta
const oktaAuth = new OktaAuth({
  issuer: environment.okta.issuer,
  clientId: environment.okta.clientId,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email'],
  pkce: true
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withViewTransitions()),
    provideAnimationsAsync(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom([
      OktaAuthModule,   // 👈 potrzebne w 6.x
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http, `/i18n/`),
          deps: [HttpClient]
        }
      })
    ]),

    // Twoje interceptory …
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat: 'yyyy-MM-dd' } },
    { provide: MAT_DATE_LOCALE, useValue: DEFAULT_LANG },
    { provide: LOCALE_ID, useValue: DEFAULT_LANG },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorCatchingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ConfirmDeleteInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },

    // 👇 kluczowe w 6.x
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    }
  ]
};
